import { render } from "./digitalPlatformPage.vue?vue&type=template&id=8a51eb5e&scoped=true"
import script from "./digitalPlatformPage.vue?vue&type=script&lang=js"
export * from "./digitalPlatformPage.vue?vue&type=script&lang=js"

import "./digitalPlatformPage.vue?vue&type=style&index=0&id=8a51eb5e&lang=less&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/NM12r8skh/0/website/official-website-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a51eb5e"]])

export default __exports__